export const colors = {
  primary: "var(--color-primary)",
  error: "var(--color-text-error)",
};
